import Image from 'next/image';
import styles from './MarketPlaceHeader.module.css';
import { IMarketPlaceMenu } from '@/interfaces';
import { NavLink } from '@/components/ui';
import React, { useEffect, useState } from 'react';
import { API } from '@/lib/helpers/http-client';
import { Input as InputText } from '../../../components/ui/input';
import { useGlobalContext } from '@/lib/context';
import { ILoginData } from '@/interfaces/ILogin';
import { pushRoute } from '@/lib/helpers/common';
import { getCookie } from '@/lib/helpers/Cookie';
type props = {
    marketPlaceHeaderData: IMarketPlaceMenu[]
    isUserLogin: ILoginData | null
}
export function MarketPlaceHeader({ marketPlaceHeaderData, isUserLogin }: props) {
    const baseUrl = process.env.SITE_URL;
    const { props: { isMobileView, isAppView } } = useGlobalContext();
    const [sidebar, setSidebar] = useState(false);
    const [sidebarSubmenu, setSidebarSubmenu] = useState(-1);
    const [search, setSearch] = useState('');
    const [dropdownData, setDropdownData] = useState<any>({});
    const [isSomeThingInCart, setIsSomeThingInCart] = useState(false);
    const fetchData = async (inputVal: string) => {
        if (inputVal.trim() != '' && inputVal.length > 1) {
            let list = await API.post(`/api/mktproductsearch?searchText=${inputVal}`);
            if (list && list.data) {
                setDropdownData(list.data)
            }
        } else {
            setDropdownData({})
        }
    };
    const handleClick = (e: any, index: number) => {
        e.preventDefault();
        if (sidebarSubmenu == index) {
            setSidebarSubmenu(-1)
        } else {
            setSidebarSubmenu(index)
        }
    }
    useEffect(() => {
        const handleClick = (event: any) => {
            event.target.id != 'serchDropDown' && setDropdownData({});
        };
        document.addEventListener('click', handleClick);
        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, []);
    useEffect(() => {
        const timer = setTimeout(() => {
            fetchData(search);
        }, 500);
        return () => clearTimeout(timer);
    }, [search]);

    const highlightSearchTerm = (text: string, term: string) => {
        const regex = new RegExp(`(${term})`, 'gi');
        return text.replace(regex, '<b>$1</b>');
    };
    const cartCookie = getCookie('cart') || "[]";

    useEffect(() => {
        const cartItems = JSON.parse(cartCookie);
        setIsSomeThingInCart(cartItems.length > 0);
    }, [cartCookie]);
    return (
        <>
            <div className={styles.placeHeaderBox} style={isAppView ? { position: 'sticky' } : {}}>
                <div className={`${styles.containerFull} containerFull`}>
                    <div className={styles.headerInner}>
                        {
                            !isMobileView &&
                            <ul className={styles.leftSide}>
                                {
                                    marketPlaceHeaderData && marketPlaceHeaderData.map((f, idx) =>
                                        <li className={styles.addArrow} key={idx}>
                                            <NavLink href={`${baseUrl}/online-store/${f.serviceSlug}`} >
                                                <span className={styles.headList}>{f.serviceName}</span>
                                            </NavLink>
                                            <i className={`${styles.arrow} arrow down`}></i>
                                            <div className={f.categories && f.categories.length > 10 ? `${styles.subDropdown} ${styles.asideSubDropdwn}` : styles.subDropdown} >
                                                <ul>
                                                    {f.categories && f.categories.map((m, idx2) =>
                                                        <li key={idx2}><NavLink href={`${baseUrl}/online-store/${f.serviceSlug}/${m.categorySlug}`}>{m.categoryName}</NavLink></li>
                                                    )}
                                                </ul>
                                            </div>

                                        </li>
                                    )}
                            </ul>
                        }
                        <div className={styles.rightSide}>
                            {
                                isMobileView &&
                                <div className={styles.sidebarMainBox}>
                                    <div className={sidebar ? `${styles.navToggle} ${styles.active}` : `${styles.navToggle}`} onClick={() => setSidebar(!sidebar)} >
                                        <span></span>
                                    </div>
                                    <div className={sidebar ? `${styles.sideMenu} ${styles.active}` : `${styles.sideMenu}`}>
                                        <ul style={isAppView ? { height: '100%' } : {}}>
                                            {
                                                marketPlaceHeaderData && marketPlaceHeaderData.map((f, idx) =>
                                                    <li className={sidebarSubmenu == idx ? `${styles.dropDown} ${styles.active}` : `${styles.dropDown}`} key={idx}>
                                                        <div className={styles.linkDrop} onClick={(e) => handleClick(e, idx)}>
                                                            <span className={styles.menuHead}>{f.serviceName}</span>
                                                        </div>
                                                        <ul>
                                                            {
                                                                f.categories && f.categories.map((m, idx2) =>
                                                                    <li key={idx2}><NavLink className={styles.linkName} href={`${baseUrl}/online-store/${f.serviceSlug}/${m.categorySlug}`}>{m.categoryName}</NavLink></li>
                                                                )
                                                            }
                                                            <li className={styles.menuItemflx}>
                                                                <span className={`${styles.viewAll}`} onClick={() => pushRoute(`${baseUrl}/online-store/${f.serviceSlug}`)}>View All</span>
                                                                <NavLink href={`${baseUrl}/online-store/${f.serviceSlug}`}>{f.serviceName}</NavLink>
                                                            </li>

                                                        </ul>
                                                    </li>
                                                )}
                                        </ul>
                                    </div>
                                </div>
                            }
                            <div className={styles.searchBox}>
                                <InputText type="text" autoComplete='off' value={search} onChange={(e) => setSearch(e.target.value)} className="formControl" placeholder='What are you looking for ?' required={true} onKeyDown={(e) => { e.key === 'Enter' && dropdownData.products && dropdownData.products.length === 1 && pushRoute(`${baseUrl}/online-store/${dropdownData.products[0].productSlug}`) }} />
                                <div className={styles.searchIcon}>
                                    <Image src="/assets/images/marketplace/searchIcon.svg" alt="Search" width={16} height={17} />
                                </div>
                                {
                                    dropdownData && Object.keys(dropdownData).length > 0 && dropdownData.products.length > 0 &&
                                    <div id="myDropdown" className={`${styles.dropdownList} ${styles.active}`}>
                                        <ul>
                                            <li>
                                                <p className="text222 font12 f600">Dive into categories</p>
                                                {
                                                    dropdownData.categories && dropdownData.categories.length > 0 && dropdownData.categories.map((f: { categoryName: string, categorySlug: string }, idx: number) =>
                                                        <NavLink key={idx} href={`${baseUrl}/online-store/${f.categorySlug}`} className={styles.link}>
                                                            <span dangerouslySetInnerHTML={{ __html: highlightSearchTerm(f.categoryName, search) }} />
                                                        </NavLink>
                                                    )
                                                }
                                            </li>
                                            <li>
                                                <p className="text222 font12 f600">Dive into sub categories</p>
                                                {
                                                    dropdownData.subcategories && dropdownData.subcategories.length > 0 && dropdownData.subcategories.map((f: { subcategoryName: string, subcategorySlug: string, bestMatchFieldName: string, bestMatchFieldValue: string }, idx: number) =>
                                                        <NavLink key={idx} href={`${baseUrl}/online-store/${f.subcategorySlug}`} className={styles.link}>
                                                            <div className={styles.detailBox} onClick={() => (f.bestMatchFieldName !== "" && f.bestMatchFieldValue !== "" && localStorage.setItem(`${f.subcategorySlug.split('/')[1]}-filterattr`, JSON.stringify({ AttributeNameSlug: f.bestMatchFieldName, AttributeValueSlug: f.bestMatchFieldValue })))}
                                                                dangerouslySetInnerHTML={{ __html: highlightSearchTerm(f.subcategoryName, search) }}>
                                                            </div>
                                                        </NavLink>
                                                    )
                                                }
                                            </li>
                                            <li>
                                                <div className={styles.diveCategBox}>
                                                    <p className="text222 font12 f600">Dive into products</p>
                                                    {
                                                        dropdownData.products && dropdownData.products.length > 0 && dropdownData.products.map((f: { productName: string, productSlug: string, productImage: string }, idx: number) =>
                                                            <NavLink key={idx} href={`${baseUrl}/online-store/${f.productSlug}`} className={styles.catgListTile}>
                                                                <div className={styles.detailBox}>
                                                                    <figure>
                                                                        <Image
                                                                            alt={f.productName}
                                                                            src={f.productImage}
                                                                            width={40}
                                                                            height={40}
                                                                        />
                                                                    </figure>
                                                                    <p className="text222 font12" dangerouslySetInnerHTML={{ __html: highlightSearchTerm(f.productName, search) }} />
                                                                </div>
                                                            </NavLink>
                                                        )
                                                    }
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                }
                            </div>
                            <NavLink href={(isUserLogin && Object.keys(isUserLogin).length != 0) ? `${baseUrl}/in/dashboard?type=my-wishlist` : `${baseUrl}/in/login?redirectPath=online-store`}>
                                <div className={styles.whishListStat}>
                                    <Image src="/assets/images/marketplace/heartBlackBorder.svg" alt="whishList" width={17} height={15} />
                                </div>
                            </NavLink>
                            <NavLink href={`${baseUrl}/checkout/cart`}>
                                <div className={`${styles.whishListStat} ${styles.cart} ${isSomeThingInCart ? styles.active : ""}`}>
                                    <Image src="/assets/images/marketplace/cart-black-border.svg" alt="cart" width={17} height={15} />
                                </div>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}